import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import DashboardHeader from './dashboardHeader'
import DashBoardContainer from '../../components/containers/dashboardContainer'
import profile_icon from '../../assets/images/icons/profile-icon.png'
import TextField from '../../components/textField'
import CheckBox from '../../components/checkbox'
import GenderInput from '../../components/genderInput'
import {useHistory} from 'react-router-dom'
import ImageUploadCtn from '../../components/imageUploadFrame'
import ImageAvatarField from '../../components/ImageAvatarField'
import ImageCropModal from '../../components/ImageCropModel'
import DragAndDrop from '../../components/dragAndDrop/file-upload.component'
import VerticalSelectField from '../../components/selectField/verticalSelectField'
import CountrySelector from '../../components/countrySelector'
import {
    submitIndividualApplication,
    updateIndividualApplication,
    fetchIndividualApplicationReport,
    fetchFile,
    fetchAwardTypes,
    editMembership
} from '../../actions'
import DatePicker from '../../components/datePicker'
import {
    SUBMIT_APPLICATION_ID,
    GENERATE_FILE_STRING_ID,
    EDIT_MEMBERSHIP_LOADING_ID
} from '../../store/loaders'
import { v4 as uuidv4 } from 'uuid'
import PopupModel from '../../components/models/popupModel'




const idTypes = [
    { value: 'idNumber', label: 'ID Number' },
    { value: 'passport', label: 'Passport'},
  ];


const ApplicationPersonaldetails = (props)=>{

    const history = useHistory()
    const initialImage  = undefined;
    const dispatch = useDispatch()

    const apiResponse = useSelector(state=>{
        const {
            loader,
            hasUpdatedIndividualApplication,
            fetchFile,
            submittedApplication,
            individualApplicationReport,
            awardTypes,
            hasEditedMembership
        } = state
        const {isLoading} = loader[SUBMIT_APPLICATION_ID] || {isLoading: false}

        const {message} = hasUpdatedIndividualApplication
        const {file} = fetchFile
        const {response} = submittedApplication
        const fileLoader = loader[GENERATE_FILE_STRING_ID] || false
        const {application} = individualApplicationReport
        const {awardType} = awardTypes
        const {edited} = hasEditedMembership
        const editLoader = loader[EDIT_MEMBERSHIP_LOADING_ID] || false
        return{
            isLoading,
            application,
            message,
            fileLoader,
            file,
            response,
            awardType,
            editLoader,
            edited
        }
    })


    const actionLoader = apiResponse.isLoading
    const loaderFile = apiResponse.fileLoader?.isLoading || false
    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    const appId = props.location.state && props.location.state.application?.id
    const isMember = props.location.state && props.location.state?.isMember



    const [tempAvatarImage,
      setTempAvatarImage] = useState(initialImage);
    const [croppedImagePath,
        setCroppedImagePath] = useState();
    const [isCropImageModalVisible,
        setIsCropImageModalVisible] = useState(false);
    const [newUserInfo, setNewUserInfo] = useState('');
    const [userCV, setUserCV] = useState('')
    const [technicalReport, setTechnicalReport] = useState('')

    const [requestId, setRequestId] = useState('')
    const [hasDownloaded, setHasDownloaded] = useState(false)
    const [download, setDownload] = useState(false)

    const [idNumberError, setIdNumberError] = useState(false)
    const [idNumberHelperText, setIdNumberHelperText] = useState('')

    const [dateError, setDateError] = useState(false)
    const [dateErrorText, setDateErrorText] = useState('')

    const [fileModel, showFileModel] = useState(false)

    const [applicationDetails,
        setApplicationDetails] = useState({})

    useEffect(()=>{
        if(apiResponse.application){
            setApplicationDetails({
                ...apiResponse.application,
            })
        }
    },[apiResponse.application])


    useEffect(()=>{
        dispatch(fetchAwardTypes())
        if(isMember){
            setApplicationDetails(props.location.state.application)
        }else{
            dispatch(fetchIndividualApplicationReport(appId))
        }
    },[])


    useEffect(()=>{
        if(apiResponse.edited === requestId){
        history.push({
            pathname: '/membership',
            state: {
                // application: applicationDetails
            }
        })
        }
    },[apiResponse.edited])


    useEffect(()=>{
        if(apiResponse.message === requestId){
            history.push('/dashboard')
        }
    },[apiResponse.message])

    var idScanUrl

    const updateUploadedFiles = (files) =>{
        setNewUserInfo(files);
    }

    const handleTechnicalReport = (files) =>{
        setTechnicalReport(files)
    }

    const handleUpdateCv = (files) =>{
        setUserCV(files)
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    useEffect(()=>{
        if(apiResponse.file?.fileText != null && !hasDownloaded && download){
            var a = document.createElement("a");
            a.href =  "data:image/" +apiResponse.file?.type +";base64," + apiResponse.file?.fileText; 
            a.download = apiResponse.file?.name || 'File' + "." + apiResponse.file?.type || ''; 
            a.click();
            setHasDownloaded(true)
        }
    },[apiResponse.file])

    useEffect(()=>{
        if(croppedImagePath){
            setApplicationDetails({
                ...applicationDetails,
                portraitPhotoFile: {
                    fileText: croppedImagePath.split(',')[1],
                    type: croppedImagePath?.split(';')[0]?.split('/')?.pop(),
                    name: croppedImagePath?.split(';')[0]?.split('/')?.pop(),
                    changed: true
                  }
            })
        }

        if(newUserInfo.length > 0 ){
            const idUrl =  toBase64(newUserInfo[0]).then(value=>{
                idScanUrl = value
                setApplicationDetails({
                    ...applicationDetails,
                    documentFile: {
                        fileText: idScanUrl.split(',')[1],
                        type: newUserInfo[0]?.name.split('.')?.pop(),
                        name: newUserInfo[0]?.name,
                        changed: true
                      }
                })
            })
        }
        if(userCV.length > 0) {
            const idUrl =  toBase64(userCV[0]).then(value=>{
                idScanUrl = value
                setApplicationDetails({
                    ...applicationDetails,
                    cv: {
                        fileText: idScanUrl.split(',')[1],
                        type: userCV[0]?.name.split('.')?.pop(),
                        name: userCV[0]?.name,
                        changed: true
                      }
                })
            })
        }
        if(technicalReport.length > 0){
            const idUrl =  toBase64(technicalReport[0]).then(value=>{
                idScanUrl = value
                setApplicationDetails({
                    ...applicationDetails,
                    technicalReportFile: {
                        fileText: idScanUrl.split(',')[1],
                        type: technicalReport[0]?.name.split('.')?.pop(),
                        name: technicalReport[0]?.name,
                        changed: true
                      }
                })
            })
        }
    },[croppedImagePath,newUserInfo, userCV, technicalReport])

    var awardTypesArr
    if(apiResponse.awardType?.length> 0){
        awardTypesArr = apiResponse.awardType.map((value, id)=>{
            return{value: value.id, label: value.name}
        })
    }

    const handleSubmit = async ()=>{
        history.push({
            pathname: '/applicant/contact-details',
            state: {
                application:  applicationDetails
            }
        })
        const reqId = uuidv4()
        setRequestId(reqId)
        if(applicationId){
            const sentData = {
                ...applicationDetails,
                step: '2',
            }
            dispatch(updateIndividualApplication({
                data:{
                    ...sentData
                },
                id:applicationId,
                reqId : reqId
            }
            ))
        }else{
            dispatch(submitIndividualApplication({
                data:{
                    ...applicationDetails
                },
                reqId:reqId
            }))    
        }
    }

    const handleSaveForLater =  ()=>{
        const reqId = uuidv4()
        setRequestId(reqId)
        if(applicationId){
            const sentData = {
                ...applicationDetails,
                step: '2',
            }
            dispatch(updateIndividualApplication({
                data:{
                    ...sentData
                },
                id:applicationId,
                reqId : reqId
            }
            ))
        }else{
            dispatch(submitIndividualApplication({
                data:{
                    ...applicationDetails
                },
                reqId:reqId
            }))    
        }
    }

    const handleRemoveItem = ()=>{
        setApplicationDetails({
            ...applicationDetails,
            documentFile:{
                fileText: '',
                name: '',
                type: '',
                changed: '',
                deleted: true
            }
        })
    }

    const handleRemoveTechnicalReport = ()=>{
        setApplicationDetails({
            ...applicationDetails,
            technicalReportFile:{
                fileText: '',
                name: '',
                type: '',
                changed: '',
                deleted: true
            }
        })
    }

    const handleRemoveCv = () =>{
        setApplicationDetails({
            ...applicationDetails,
            cv:{
                fileText: '',
                name: '',
                type: '',
                changed: '',
                deleted: true
            }
        })
    }
    const downloadFile = ()=>{
        let url  
        if(applicationDetails?.documentFile?.fileText !== '' && applicationDetails?.documentFile?.fileText !== undefined ){
            url = encodeURIComponent(applicationDetails.documentFile?.fileText.substring(applicationDetails.documentFile?.fileText.indexOf("/tmp"), applicationDetails.documentFile?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }


    const downLoadTechnicalReport = ()=>{
        let url 
        if(applicationDetails?.technicalReportFile?.fileText !== '' && applicationDetails?.technicalReportFile?.fileText !== undefined ){
            url = encodeURIComponent(applicationDetails.technicalReportFile?.fileText.substring(applicationDetails.technicalReportFile?.fileText.indexOf("/tmp"), applicationDetails.technicalReportFile?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const downLoadCv = ()=>{
        let url  
        if(applicationDetails?.cv?.fileText !== '' && applicationDetails?.cv?.fileText !== undefined ){
            url = encodeURIComponent(applicationDetails.cv?.fileText.substring(applicationDetails.cv?.fileText.indexOf("/tmp"), applicationDetails.cv?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant',
            state: {
                application: applicationDetails
            }
        })
     }


     const handleMembership = () =>{
        const reqId = uuidv4()
        setRequestId(reqId)
        const sentItems = {
            cv: applicationDetails.cv,
            dateOfBirth: applicationDetails.dateOfBirth,
            documentFile: applicationDetails.documentFile,
            firstname: applicationDetails.firstname,
            gender: applicationDetails.gender,
            id: applicationDetails.id,
            identificationDocumentNumber: applicationDetails.identificationDocumentNumber,
            identificationDocumentType: applicationDetails.identificationDocumentType,
            lastname: applicationDetails.lastname,
            name: applicationDetails.name,
            portraitPhotoFile: applicationDetails.portraitPhotoFile,
            status: applicationDetails.status,
            technicalReportFile: applicationDetails.technicalReportFile,
            title: applicationDetails.title,
            userId: applicationDetails.userId,
            countryFrom: applicationDetails.countryFrom,
            awardType: applicationDetails.awardType,
            membershipClass: applicationDetails.membershipClass,
        }
        dispatch(editMembership({
            id: appId, 
            application: sentItems,
            reqId : reqId
        }))
     }

     const validateIdNumber = (number)=>{
         if(applicationDetails.identificationDocumentType !== 'Passport'){
            if(number.length !== 16){
                setIdNumberError(true)
                setIdNumberHelperText('Invalid ID number provided')
            }else{
                setIdNumberError(false)
            setIdNumberHelperText('')
            }
         }
     } 
     
    const validateDateOfBirth = (date) =>{
        var setDate = new Date('Mon Jan 01 2007 20:44:00 GMT+0200 (Central Africa Time)').getTime()
        if(setDate < new Date(date).getTime()){
            setDateError(true)
            setDateErrorText('One must be above 15 years old')
        }else{
            setApplicationDetails({
                ...applicationDetails,
                dateOfBirth:date
            })
            setDateError(false)
            setDateErrorText('')
        }
    }

    const handleCloseMembership = ()=>{
        history.goBack()
    }


    return (
        <div>
           {!isMember &&
           <DashboardHeader 
                activeStep={2}
                application={applicationDetails}
            />}
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                title="Next"
                handleSaveForLater={handleSaveForLater}
                middleTitle="Save for Later"
                loader={actionLoader}
                disabled={actionLoader}
                editLoader={apiResponse.editLoader?.isLoading}
                hasCloseBtn={isMember ? true: false}
                hasButton={isMember ? true: false}
                closeTitle="Submit"
                handleClose={handleMembership}
                handleCloseMembership={handleCloseMembership}>
               <div className="first-step-container">
                    <div style={{
                        width: '25%',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',}}>
                        <span className="upload-photo-text mb-2">
                            Upload portrait photo 
                        </span>
                        <div className="upload-phot-ctn">
                            <ImageUploadCtn
                                style={{width: '100%',display: 'flex', flexDirection: 'column', padding: '20px 0px'}}
                                onImageRejected={() => {
                                // props.setNotificationMessage({
                                //     notificationType: "ERROR",
                                //     title: 'Image size above limit',
                                //     data: {
                                //     message: 'please select an image with a size below 4mb'
                                //     }
                                // })
                                showFileModel(true)
                                }}
                                onImageAccepted={(files) => {
                                if (files.length > 0) {
                                    setTempAvatarImage(files[0]);
                                    setIsCropImageModalVisible(true);
                                }
                                }}>
                                <ImageAvatarField avatarUrl={
                                    croppedImagePath || 
                                    `data:image/${applicationDetails.portraitPhotoFile?.type};base64,${applicationDetails.portraitPhotoFile?.fileText}` ||
                                    profile_icon}/>
                            {croppedImagePath === undefined && applicationDetails.portraitPhotoFile === null ?<span style={{textAlign: 'center'}}>
                                Drop file to <br/> Upload <br/> 
                                <span className="or-text"> or </span><br/> Browse
                            </span> : null}
                            </ImageUploadCtn>
                        </div>
                    </div>
                    <div className="vertical-seperator"></div>
                    <div style={{
                        width: '40%'
                    }}>
                        <CheckBox 
                            title="Title"
                            handleTitleChange={(text)=>setApplicationDetails({
                                ...applicationDetails,
                                title: text.target.value
                            })}
                            titleValue={applicationDetails?.title}
                            required={true}
                            />
                        <TextField
                            title="Surname"
                            handleChange={text=>setApplicationDetails({
                                ...applicationDetails,
                                firstname:text.target.value
                            })}
                            value={applicationDetails?.firstname}
                            required={true}
                            />
                        <TextField
                            title="Other names"
                            handleChange={(text)=>setApplicationDetails({
                                ...applicationDetails,
                                lastname: text.target.value
                            })}
                            value={applicationDetails?.lastname}
                            required={true}
                            />
                        <GenderInput 
                            title="Gender"
                            genderValue={applicationDetails?.gender}
                            handleGenderChange={(text)=>setApplicationDetails({
                                ...applicationDetails,
                                gender: text.target.value
                            })}
                            required={true}
                            />
                        <DatePicker
                            title="Date of Birth"
                            handleDateOfBirth={(date)=>
                            validateDateOfBirth(date)
                        }
                            error={dateError}
                            helperText={dateErrorText}
                            dateOfBirth={applicationDetails?.dateOfBirth || null}
                            required={true}/>
                        <CountrySelector
                            title="Nationaliy"
                            handleNationality={(value)=>setApplicationDetails({
                                ...applicationDetails,
                                countryFrom:{
                                    name: value.label,
                                    id: value.value
                                }
                            })}
                            nationality={{value: applicationDetails?.countryFrom?.id, label:applicationDetails?.countryFrom?.name }}
                            required={true}
                            />

                        <VerticalSelectField
                            title="Education Level"
                            options={awardTypesArr}
                            handleChange={(text)=>{
                                setApplicationDetails({
                                ...applicationDetails,
                                awardType:{
                                    name: text.label,
                                    id:text.value
                                }
                            })}
                        }
                            selectedOption={{label: applicationDetails.awardType?.name, value: applicationDetails.awardType?.id}}
                            required={true}
                            />
                    </div>
                    <div className="vertical-seperator"></div>
                    <div style={{
                        width: '35%'
                    }}>
                        <VerticalSelectField
                            title="ID Type"
                            options={idTypes}
                            handleChange={(type)=>setApplicationDetails({
                                ...applicationDetails,
                                identificationDocumentType: type.label
                            })}
                            selectedOption={{label: applicationDetails.identificationDocumentType, value: applicationDetails.identificationDocumentType}}
                            required={true}
                            />

                        <TextField
                            title="ID Number"
                            type={applicationDetails.identificationDocumentType === 'Passport'? 'text': 'number'}
                            onBlur={(text)=>validateIdNumber(text.target.value)}
                            handleChange={(text)=>{
                                if(applicationDetails.identificationDocumentType === 'Passport'){
                                    setIdNumberError(false)
                                    setIdNumberHelperText('')
                                }
                                setApplicationDetails({
                                ...applicationDetails,
                                identificationDocumentNumber:text.target.value
                            })
                        }
                        }
                            value={applicationDetails.identificationDocumentNumber}
                            error={idNumberError}
                            helperText={idNumberHelperText}
                            required={true}
                            />
                        <div className="attach-id-card-container">
                            <span className="general-span-text-none-auto">Attach ID card scan</span>
                            <DragAndDrop
                                accept=".jpg,.png,.jpeg,.pdf,.docx"
                                label=""
                                multiple
                                updateFilesCb={updateUploadedFiles}
                                previewSize={80}
                                handleRemoveItem= {handleRemoveItem}
                                savedFile={applicationDetails.documentFile}
                                downloadFile={downloadFile}
                                loaderFile={loaderFile}
                                marginLeft={20}
                                dragText={true}
                                hide={true}
                                showFileModel={showFileModel}
                                />
                        </div>  
                        <div className="attach-id-card-container">
                            <span className="general-span-text-none-auto">Attach your CV</span>
                            <DragAndDrop
                                accept=".jpg,.png,.jpeg,.pdf,.docx"
                                label=""
                                multiple
                                updateFilesCb={handleUpdateCv}
                                previewSize={80}
                                handleRemoveItem= {handleRemoveCv}
                                savedFile={applicationDetails.cv}
                                downloadFile={downLoadCv}
                                loaderFile={loaderFile}
                                marginLeft={20}
                                hide={true}
                                showFileModel={showFileModel}
                                />
                        </div>
                        {applicationDetails.applicantType?.name !== 'Firm Application' && applicationDetails.membershipClassId?.id === 1 ?  
                                <div className="attach-id-card-container">
                                    <span className="upload-photo-text">Attach Technical Report</span>
                                    <span className="notification-text">If you are a foreigner, please provide the current practicing certificates/licence</span>
                                    <DragAndDrop
                                        accept=".jpg,.png,.jpeg,.pdf"
                                        multiple
                                        updateFilesCb={handleTechnicalReport}
                                        fileName={applicationDetails?.technicalReportFile?.name}
                                        setApplicationDetails={setApplicationDetails}
                                        applicationDetails={applicationDetails}
                                        handleRemoveItem= {handleRemoveTechnicalReport}
                                        savedFile={applicationDetails.technicalReportFile}
                                        downloadFile={downLoadTechnicalReport}
                                        loaderFile={loaderFile}
                                        marginLeft={20}
                                        hide={true}
                                        showFileModel={showFileModel}
                                        />
                        </div>: null}  
                    </div>
               </div>
               <ImageCropModal
                imagePath={tempAvatarImage
                    ? URL.createObjectURL(tempAvatarImage)
                    : ''}
                    onCropSelected={(croppedImage) => {
                    setCroppedImagePath(croppedImage);
                    setIsCropImageModalVisible(false)
                  }}
                    isVisible={isCropImageModalVisible}
                    handleHide={() => {
                    setIsCropImageModalVisible(false)
                  }}/>
                <PopupModel
                    show={fileModel}
                    hide={()=>showFileModel(false)}
                    content="A file should not exceed 5MB's"
                    btnText="OK"
                    handleConfirm={()=>showFileModel(false)}
                    />
            </DashBoardContainer>
        </div>
    )
}

export default ApplicationPersonaldetails